import { units } from '@ui/css';
import { combineTokens, makeSelectors } from '@utils/css';

const transitionDurationMs = {
  enter: 200,
  exit: 150
};
const modalTokens = combineTokens("--modal", {
  maxHeight: `calc(${units.vh(100)} - ${units.px(80)})`,
  maxWidth: `calc(${units.vw(100)} - ${units.px(80)})`
});
const wrapper = "dibwcxzu8";
const modal = "dibmce7dmb";
const scrollContainer = "dibs1o6el6q";
const speechButton = "dibs7z5pp1";
const backdrop = "dibbn4h797";
const closeButton = "dibc15yp58i";
const modalSelectors = makeSelectors({
  wrapper,
  scrollContainer,
  backdrop,
  closeButton,
  modal,
  speechButton
});

export { backdrop, closeButton, modal, modalSelectors, modalTokens, scrollContainer, speechButton, transitionDurationMs, wrapper };
import "./modal.style.linaria.module.css";
//# sourceMappingURL=modal.style.js.map
